

import { css } from 'lit';

export const styles = css`
  :host {
    height: 100%;
    flex-groW: 1;
    flex-shrink: 0;
    display: flex;
    width: calc(100% - 350px);

    .note-editor,
    .note-preview {
      flex-grow: 1;
      width: 50%;
    }

    .note-preview {
      background: #fff;
      color: #222;
      padding: 10px;
      overflow: auto;

      &.hidden {
        display: none;
      }
    }

    .root-wrapper {
      display: flex;
      flex-direction: row;

      .cm-editor {
        width: 0;
        flex-grow: 1;
      }
    }

    .cm-activeLineGutter,
    .cm-activeLine:not(.cm-line) {
      background: #222;
    }

    .cm-activeLine {
      background-color: rgb(82 84 85 / 27%);
    }

    .cm-gutters {
      background: #222;
      border: none;
    }

    section,
    section>div {
      height: 100%;
      background: #222;
    }
  }

`;